import { useState } from "react";
import { useIntl } from "react-intl";
import { NavLink } from "react-router-dom";
import {
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  SvgIcon,
  Switch,
  useColorScheme,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import DashboardCustomizeIcon from "@mui/icons-material/DashboardCustomize";
import DarkModeIcon from "@mui/icons-material/DarkMode";

import { LogoutIcon, Nancie, RevbellIcon } from "../../components/icons";
import { MenuItemLink, menuPaperStyles, RevbellMenuItem } from "./Menu";
import CustomerDropdown from "./CustomerDropdown";
import { DRAWER_WIDTH_OPEN } from "../utils";

type Props = {
  menuItems?: RevbellMenuItem;
};

const BurgerMenu = ({ menuItems }: Props) => {
  const intl = useIntl();

  const [openMenu, setOpenMenu] = useState(false);
  const { mode, setMode } = useColorScheme();

  return (
    <>
      <IconButton
        onClick={() => setOpenMenu(true)}
        size="large"
        sx={{ py: 1.5, px: 0 }}
      >
        <MenuRoundedIcon fontSize="medium" />
      </IconButton>
      <Drawer
        anchor={"left"}
        open={openMenu}
        onClose={() => setOpenMenu(false)}
        slotProps={{
          paper: {
            sx: (theme) => ({
              ...menuPaperStyles(theme),
              width: DRAWER_WIDTH_OPEN,
            }),
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <List>
            <ListItem sx={{ mb: 1 }}>
              <Box sx={{ "& svg": { width: "25px", height: "25px" } }}>
                <RevbellIcon />
              </Box>
            </ListItem>
            <CustomerDropdown open={true} popoverMinWidth={150} />
            <ListItem>
              <MenuItemLink component={NavLink} to="/data-assistant/">
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    mr: 1.25,
                    "& svg": { width: "15px", height: "15px" },
                  }}
                >
                  <Nancie />
                </Box>
                <ListItemText
                  primary={intl.formatMessage({ id: "IA_NANCIE_MENU" })}
                />
              </MenuItemLink>
            </ListItem>
            {menuItems && (
              <ListItem>
                <MenuItemLink
                  component={NavLink}
                  to={
                    menuItems.isReactPage
                      ? menuItems.reactRoute
                      : menuItems.urlPath
                  }
                >
                  <SvgIcon fontSize="small" sx={{ mr: 1.25 }}>
                    <DashboardCustomizeIcon />
                  </SvgIcon>
                  <ListItemText primary={menuItems.translated_name} />
                </MenuItemLink>
              </ListItem>
            )}
          </List>
          <List>
            <ListItem>
              <DarkModeIcon
                sx={{
                  mr: 1.25,
                  width: "20px",
                  height: "20px",
                  color: "menu.text",
                }}
              />
              <ListItemText
                id="dark-theme-switch-label"
                sx={{ color: "menu.text" }}
                primary={intl.formatMessage({ id: "DARK_THEME" })}
              />
              <Switch
                edge="end"
                onChange={() => setMode(mode === "dark" ? "light" : "dark")}
                checked={mode === "dark"}
                slotProps={{
                  input: { "aria-labelledby": "dark-theme-switch-label" },
                }}
              />
            </ListItem>
            <ListItem>
              <MenuItemLink component={NavLink} to="/logout">
                <SvgIcon
                  fontSize="small"
                  sx={{
                    mr: 1.5,
                    width: "18px",
                    height: "18px",
                    color: "menu.text",
                  }}
                >
                  <LogoutIcon />
                </SvgIcon>
                <ListItemText
                  primary={intl.formatMessage({ id: "DISCONNECT" })}
                />
              </MenuItemLink>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </>
  );
};
export default BurgerMenu;
